var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07034 5.88921H6.237M10.5835 9.59147L13.6834 11.1184C14.0048 11.314 14.342 11.1987 14.3333 10.7908L14.3116 5.39435C14.2842 4.95144 14.0228 4.83058 13.6379 5.03527L10.5748 6.42737M3.5 12.3337H9.07033C9.89876 12.3337 10.5703 11.6704 10.5703 10.8522L10.5835 8.95202L10.5703 5.14847C10.5703 4.33027 9.89876 3.66699 9.07033 3.66699H3.5C2.67157 3.66699 2 4.33027 2 5.14847V10.8522C2 11.6704 2.67157 12.3337 3.5 12.3337Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesVideo);
export default __webpack_public_path__ + "static/media/yes-video.4171c490de6f352fd59bf47e52021915.svg";
export { ForwardRef as ReactComponent };